<template>
  <PageLayout title="Detail Pesan Keluar">
    <template #actions>
      <router-link to="/outgoing" class="btn btn-light border">
        Kembali
      </router-link>
      <button
        v-if="canResend"
        type="button"
        class="btn btn-warning text-white"
        :disabled="actionLoading"
        @click="resendOutgoing"
      >
        Kirim Ulang
      </button>
      <button
        type="button"
        class="btn btn-danger text-white"
        :disabled="actionLoading"
        @click="deleteOutgoing"
      >
        Hapus
      </button>
    </template>

    <div v-if="isLoading" class="content-card text-center py-5">
      <div class="spinner-border spinner" role="status"></div>
    </div>

    <template v-else>
      <div class="outgoing-detail-status" :class="statusBannerClass">
        <div class="outgoing-detail-status__main">
          <span class="outgoing-detail-status__badge">{{ statusLabel }}</span>
          <span class="outgoing-detail-status__id">ID #{{ outgoing.id }}</span>
        </div>
        <p v-if="note" class="outgoing-detail-status__note mb-0">{{ note }}</p>
      </div>

      <div class="row">
        <div class="col-lg-5">
          <div class="content-card outgoing-detail-card">
            <h6 class="outgoing-detail-card__title">Pengirim</h6>
            <dl class="outgoing-detail-dl">
              <div>
                <dt>Device</dt>
                <dd>{{ deviceName }}</dd>
              </div>
              <div>
                <dt>Nomor Device</dt>
                <dd>{{ deviceNumber }}</dd>
              </div>
              <div>
                <dt>Status Device</dt>
                <dd>
                  <span class="badge" :class="deviceStatusClass">{{ deviceStatus }}</span>
                </dd>
              </div>
              <div v-if="outgoing.device_id">
                <dt>Device ID</dt>
                <dd class="text-monospace">{{ outgoing.device_id }}</dd>
              </div>
            </dl>
          </div>

          <div class="content-card outgoing-detail-card">
            <h6 class="outgoing-detail-card__title">Penerima</h6>
            <dl class="outgoing-detail-dl">
              <div>
                <dt>Nomor Tujuan</dt>
                <dd class="outgoing-detail-phone">{{ outgoing.to || '-' }}</dd>
              </div>
              <div v-if="outgoing.from">
                <dt>Dari (From)</dt>
                <dd>{{ outgoing.from }}</dd>
              </div>
            </dl>
          </div>

          <div class="content-card outgoing-detail-card">
            <h6 class="outgoing-detail-card__title">Jadwal & Pengiriman</h6>
            <dl class="outgoing-detail-dl">
              <div>
                <dt>Jadwal Kirim</dt>
                <dd>{{ formatDate(outgoing.jadwal) }}</dd>
              </div>
              <div>
                <dt>Delay</dt>
                <dd>{{ outgoing.delay || 0 }} detik</dd>
              </div>
              <div v-if="outgoing.last_send">
                <dt>Terakhir Dikirim</dt>
                <dd>{{ outgoing.last_send }}</dd>
              </div>
              <div>
                <dt>Dibuat</dt>
                <dd>{{ formatDate(outgoing.created_at) }}</dd>
              </div>
              <div>
                <dt>Diperbarui</dt>
                <dd>{{ formatDate(outgoing.updated_at) }}</dd>
              </div>
            </dl>
          </div>

          <div class="content-card outgoing-detail-card">
            <h6 class="outgoing-detail-card__title">Informasi Lain</h6>
            <dl class="outgoing-detail-dl">
              <div v-if="outgoing.message_id">
                <dt>Message ID (WA)</dt>
                <dd class="text-monospace text-break">{{ outgoing.message_id }}</dd>
              </div>
              <div v-if="outgoing.blast_id">
                <dt>Blast ID</dt>
                <dd class="text-break text-monospace">{{ outgoing.blast_id }}</dd>
              </div>
              <div v-if="outgoing.mode">
                <dt>Mode / Sumber</dt>
                <dd>{{ outgoing.mode }}</dd>
              </div>
              <div>
                <dt>Turbo</dt>
                <dd>{{ outgoing.turbo ? 'Ya' : 'Tidak' }}</dd>
              </div>
            </dl>
          </div>
        </div>

        <div class="col-lg-7">
          <div class="content-card outgoing-detail-card outgoing-detail-card--message">
            <h6 class="outgoing-detail-card__title">Isi Pesan</h6>

            <div v-if="messageText" class="outgoing-detail-message">
              <pre class="outgoing-detail-message__text">{{ messageText }}</pre>
            </div>
            <p v-else class="text-muted mb-0">Tidak ada teks pesan.</p>

            <div v-if="mediaUrl" class="outgoing-detail-media mt-4">
              <h6 class="outgoing-detail-card__subtitle">Lampiran Media</h6>
              <div v-if="isImageMedia" class="outgoing-detail-media__preview">
                <img :src="mediaUrl" alt="Media pesan" @error="onMediaError">
              </div>
              <div v-else class="outgoing-detail-media__file">
                <i class="fas fa-paperclip mr-2"></i>
                <a :href="mediaUrl" target="_blank" rel="noopener noreferrer">Buka file lampiran</a>
              </div>
              <p class="text-muted small text-break mt-2 mb-0">{{ mediaUrl }}</p>
            </div>
          </div>

          <div class="content-card outgoing-detail-card">
            <h6 class="outgoing-detail-card__title">Timeline</h6>
            <ul class="outgoing-detail-timeline">
              <li class="done">
                <span class="outgoing-detail-timeline__label">Pesan dibuat</span>
                <span class="outgoing-detail-timeline__time">{{ formatDate(outgoing.created_at) }}</span>
              </li>
              <li :class="{ done: isScheduledOrLater }">
                <span class="outgoing-detail-timeline__label">Dijadwalkan</span>
                <span class="outgoing-detail-timeline__time">{{ formatDate(outgoing.jadwal) }}</span>
              </li>
              <li :class="{ done: isSent, failed: isFailed }">
                <span class="outgoing-detail-timeline__label">
                  {{ isSent ? 'Terkirim' : isFailed ? 'Gagal dikirim' : 'Menunggu pengiriman' }}
                </span>
                <span class="outgoing-detail-timeline__time">
                  {{ isSent || isFailed ? formatDate(outgoing.updated_at) : '-' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import moment from 'moment'
import PageLayout from '@/components/layouts/PageLayout.vue'

export default {
  components: { PageLayout },
  data() {
    return {
      id: '',
      outgoing: {},
      isLoading: true,
      actionLoading: false,
      mediaLoadFailed: false,
    }
  },
  computed: {
    device() {
      return this.outgoing.device || null
    },
    deviceName() {
      return this.device?.name || 'Device tidak ditemukan'
    },
    deviceNumber() {
      return this.device?.number || '-'
    },
    deviceStatus() {
      return this.device?.status || 'TIDAK DIKETAHUI'
    },
    deviceStatusClass() {
      return this.deviceStatus === 'CONNECTED' ? 'badge-success' : 'badge-secondary'
    },
    messageText() {
      return this.outgoing.text || ''
    },
    mediaUrl() {
      return this.outgoing.file || ''
    },
    note() {
      return this.outgoing.keterangan || this.outgoing.note || ''
    },
    normalizedStatus() {
      return (this.outgoing.status || '').toLowerCase()
    },
    isSent() {
      return this.normalizedStatus === 'terkirim'
    },
    isFailed() {
      return this.normalizedStatus === 'gagal'
    },
    isPending() {
      return ['menunggu jadwal', 'dalam antrian', 'dijadwalkan', 'menunggu device terkoneksi'].includes(this.normalizedStatus)
    },
    isScheduledOrLater() {
      return this.isSent || this.isFailed || this.isPending
    },
    statusLabel() {
      const map = {
        terkirim: 'Terkirim',
        gagal: 'Gagal',
        'menunggu jadwal': 'Menunggu Jadwal',
        'dalam antrian': 'Dalam Antrian',
        dijadwalkan: 'Dijadwalkan',
        'menunggu device terkoneksi': 'Menunggu Device Terkoneksi',
      }
      return map[this.normalizedStatus] || this.outgoing.status || 'Tidak diketahui'
    },
    statusBannerClass() {
      if (this.isSent) return 'is-success'
      if (this.isFailed) return 'is-danger'
      if (this.isPending) return 'is-warning'
      return 'is-muted'
    },
    isImageMedia() {
      if (!this.mediaUrl || this.mediaLoadFailed) return false
      return /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(this.mediaUrl)
    },
    canResend() {
      if (this.note === 'Nomor tidak terdaftar') return false
      return this.isFailed || this.isPending
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.loadData()
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      const tz = this.$store?.state?.auth?.user?.timezone
      if (tz !== undefined && tz !== null && tz !== '') {
        return moment(date).utcOffset(tz).format('YYYY-MM-DD HH:mm:ss')
      }
      return moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss')
    },
    onMediaError() {
      this.mediaLoadFailed = true
    },
    async loadData() {
      this.isLoading = true
      this.mediaLoadFailed = false
      try {
        const id = this.$route.query.id
        const detail = await this.$store.dispatch('outgoing_detail', { id })
        this.outgoing = detail.data.data.outgoing || {}
        if (!this.outgoing.device) {
          this.$toast.warning('Device pengirim tidak ditemukan')
        }
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal memuat detail pesan')
        this.$router.push('/outgoing')
      }
      this.isLoading = false
    },
    async resendOutgoing() {
      this.actionLoading = true
      try {
        const response = await this.$store.dispatch('outgoing_resend', {
          message_id: parseInt(this.id, 10),
        })
        this.$toast.success(response.data.message)
        await this.loadData()
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal mengirim ulang')
      }
      this.actionLoading = false
    },
    async deleteOutgoing() {
      const ok = await this.$confirm({
        title: 'Hapus Pesan',
        message: 'Yakin ingin menghapus pesan keluar ini?',
        confirmText: 'Hapus',
      })
      if (!ok) return
      this.actionLoading = true
      try {
        const response = await this.$store.dispatch('outgoing_delete', { id: this.id })
        this.$toast.success(response.data.message)
        this.$router.push('/outgoing')
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal menghapus pesan')
      }
      this.actionLoading = false
    },
  },
}
</script>

<style scoped>
.outgoing-detail-status {
  border-radius: var(--wc-radius-lg, 12px);
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid transparent;
}

.outgoing-detail-status.is-success {
  background: #e8f7f0;
  border-color: #b8e6cf;
  color: #0d6b4c;
}

.outgoing-detail-status.is-danger {
  background: #fdeeee;
  border-color: #f5c2c2;
  color: #b42318;
}

.outgoing-detail-status.is-warning {
  background: #fff8e6;
  border-color: #ffe08a;
  color: #8a6100;
}

.outgoing-detail-status.is-muted {
  background: var(--wc-bg-subtle, #f4f6f8);
  border-color: var(--wc-border, #e3e8ef);
  color: var(--wc-text, #333);
}

.outgoing-detail-status__main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.outgoing-detail-status__badge {
  font-weight: 600;
  font-size: 1rem;
}

.outgoing-detail-status__id {
  font-size: 0.875rem;
  opacity: 0.85;
}

.outgoing-detail-status__note {
  margin-top: 0.5rem;
  font-size: 0.875rem;
}

.outgoing-detail-card__title {
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--wc-text-muted, #6c757d);
  margin-bottom: 1rem;
}

.outgoing-detail-card__subtitle {
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.outgoing-detail-card--message {
  min-height: 200px;
}

.outgoing-detail-dl {
  margin: 0;
}

.outgoing-detail-dl > div {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--wc-border, #edf0f3);
}

.outgoing-detail-dl > div:last-child {
  border-bottom: none;
}

.outgoing-detail-dl dt {
  font-size: 0.8125rem;
  color: var(--wc-text-muted, #6c757d);
  font-weight: 500;
  margin: 0;
  flex: 0 0 42%;
}

.outgoing-detail-dl dd {
  font-size: 0.875rem;
  margin: 0;
  text-align: right;
  word-break: break-word;
}

.outgoing-detail-phone {
  font-weight: 600;
  font-size: 1rem;
}

.outgoing-detail-message__text {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 0.9375rem;
  line-height: 1.6;
  margin: 0;
  padding: 1rem;
  background: var(--wc-bg-subtle, #f8f9fa);
  border-radius: var(--wc-radius-md, 8px);
  border: 1px solid var(--wc-border, #e3e8ef);
  max-height: 420px;
  overflow: auto;
}

.outgoing-detail-media__preview img {
  max-width: 100%;
  max-height: 360px;
  border-radius: var(--wc-radius-md, 8px);
  border: 1px solid var(--wc-border, #e3e8ef);
}

.outgoing-detail-media__file {
  padding: 0.75rem 1rem;
  background: var(--wc-bg-subtle, #f8f9fa);
  border-radius: var(--wc-radius-md, 8px);
  border: 1px solid var(--wc-border, #e3e8ef);
}

.outgoing-detail-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.outgoing-detail-timeline li {
  position: relative;
  padding-left: 1.5rem;
  padding-bottom: 1.25rem;
}

.outgoing-detail-timeline li:last-child {
  padding-bottom: 0;
}

.outgoing-detail-timeline li::before {
  content: '';
  position: absolute;
  left: 0.35rem;
  top: 0.35rem;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  background: #cbd5e1;
}

.outgoing-detail-timeline li::after {
  content: '';
  position: absolute;
  left: 0.6rem;
  top: 1rem;
  bottom: 0;
  width: 2px;
  background: #e2e8f0;
}

.outgoing-detail-timeline li:last-child::after {
  display: none;
}

.outgoing-detail-timeline li.done::before {
  background: var(--wc-primary, #128c7e);
}

.outgoing-detail-timeline li.failed::before {
  background: #dc3545;
}

.outgoing-detail-timeline__label {
  display: block;
  font-weight: 600;
  font-size: 0.875rem;
}

.outgoing-detail-timeline__time {
  display: block;
  font-size: 0.8125rem;
  color: var(--wc-text-muted, #6c757d);
  margin-top: 0.15rem;
}
</style>
